import { Control, RegisterOptions } from "react-hook-form";
import { IGooglePickerItem } from "../Integrations/GoogleDrivePicker";
import { SpotSelectField } from "./SelectField";
import { DATA_KEYS, useRemoteData } from "@/utils/useRemoteData";
import { Banner } from "../Banner";
import { useSpotUser } from "@/utils/spotUser";

interface ISlackChannelField {
  name: string;
  label: string;
  control: Control<any>;
  rules?: RegisterOptions;
  defaultValue?: IGooglePickerItem[];
  placeholder?: string;
  isDisabled?: boolean;
}

export const SlackChannelField = ({
  label,
  name,
  placeholder,
  control,
  rules,
  isDisabled,
}: ISlackChannelField) => {
  const { spotGroup } = useSpotUser();

  const {
    data: slackInformationData,
    isError: isSlackInformationError,
    isLoading: isSlackInformationLoading,
  } = useRemoteData(DATA_KEYS.TRIGGERS_SLACK_INFO, {
    path: { group_id: spotGroup.id },
  });

  if (isSlackInformationError) {
    return (
      <Banner
        style="error"
        label="There was an error fetching your slack channels. Please try again later."
      />
    );
  }

  return (
    <SpotSelectField
      isLoading={isSlackInformationLoading}
      name={name}
      label={label}
      control={control}
      placeholder={placeholder || "Select Slack channel"}
      options={
        slackInformationData?.channels.map((u) => ({
          label: "#" + u.name,
          value: u.id,
        })) || []
      }
      isClearable
      rules={rules}
      isDisabled={isDisabled}
    />
  );
};
